/**
 * Downloads a file by passing it's file name and raw file data.
 */
const downloadFile = (fileName: string, fileData: Blob | any) => {
    const blob = fileData instanceof Blob ? fileData : new Blob([fileData]);
    const url = URL.createObjectURL(blob);

    // Create anchor element to allow blob download.
    let anchorElement = document.createElement("a") as HTMLAnchorElement | null;
    anchorElement!.href = url;
    anchorElement!.download = fileName;
    anchorElement!.target = "_blank";
    anchorElement!.style.display = "none";
    anchorElement!.click();

    // Clean up
    anchorElement = null;
    URL.revokeObjectURL(url);
};

export default downloadFile;
